import React, { useState } from "react";

const SyntraMfgComplaintHub = () => {
  const [complaints, setComplaints] = useState([
    {
      id: 1,
      title: "Delayed Raw Material Delivery",
      type: "Logistics",
      description: "Aluminum sheets arrived 3 days late, affecting production schedule.",
      location: "Pune, Maharashtra",
      status: "Open",
    },
    {
      id: 2,
      title: "Defective Machinery Component",
      type: "Quality",
      description: "The hydraulic press malfunctioned within 2 weeks of installation.",
      location: "Bengaluru, Karnataka",
      status: "In Progress",
    },
    {
      id: 3,
      title: "Payment Delay from Client",
      type: "Finance",
      description: "Invoice pending for over 30 days.",
      location: "Ahmedabad, Gujarat",
      status: "Resolved",
    },
  ]);

  const [newComplaint, setNewComplaint] = useState({
    title: "",
    type: "",
    description: "",
    location: "",
    status: "Open",
  });

  const handleChange = (e) => {
    const { name, value } = e.target;
    setNewComplaint({ ...newComplaint, [name]: value });
  };

  const handleSubmit = (e) => {
    e.preventDefault();
    if (!newComplaint.title || !newComplaint.type || !newComplaint.description || !newComplaint.location) {
      alert("Please fill in all fields before submitting.");
      return;
    }
    setComplaints([...complaints, { id: complaints.length + 1, ...newComplaint }]);
    setNewComplaint({ title: "", type: "", description: "", location: "", status: "Open" });
  };

  return (
    <section className="py-2 px-6 md:px-20 bg-black min-h-screen">
      {/* Hero Section */}
      <div className="text-center mb-2 bg-black text-white rounded-lg px-2 py-2">
        <h1 className="text-xl lg:text-2xl font-bold text-yellow-200 mb-4">
          🏭 SyntraMfg Complaint Hub
        </h1>
        <p className="text-white text-sm lg:text-lg">
          Report, track and resolve manufacturing ecosystem complaints — logistics, quality, machinery and financial — transparently.
        </p>
      </div>

      {/* Form to Create New Complaint */}
      <div className="max-w-3xl mx-auto bg-gray-800 shadow-lg rounded-2xl p-6 mb-12">
        <h2 className="text-xl font-semibold text-yellow-200 mb-4">Register a Complaint</h2>
        <form onSubmit={handleSubmit} className="grid gap-4">
          <input
            type="text"
            name="title"
            value={newComplaint.title}
            onChange={handleChange}
            placeholder="Complaint Title (e.g., Damaged Machinery Delivery)"
            className="border rounded-lg px-3 py-2 w-full"
          />

          <select
            name="type"
            value={newComplaint.type}
            onChange={handleChange}
            className="border rounded-lg px-3 py-2 w-full h-10"
          >
            <option value="">Select Complaint Type</option>
            <option>Logistics</option>
            <option>Quality</option>
            <option>Finance</option>
            <option>Machinery / Equipment</option>
            <option>Services</option>
            <option>Others</option>
          </select>

          <textarea
            name="description"
            value={newComplaint.description}
            onChange={handleChange}
            placeholder="Brief issue description"
            style={{ height: "250px", width: "100%" }}
            className="bg-gray-100 text-black border rounded-lg px-2 py-1 w-full text-sm resize-none"
          />

          <input
            type="text"
            name="location"
            value={newComplaint.location}
            onChange={handleChange}
            placeholder="Location (e.g., Mumbai, Maharashtra)"
            className="border rounded-lg px-3 py-2 w-full"
          />

          <button
            type="submit"
            className="bg-red-700 text-white py-2 rounded-lg hover:bg-red-800 transition"
          >
            🚩 Submit Complaint
          </button>
        </form>
      </div>

      {/* Complaints Table */}
      <div className="mx-auto">
        <h2 className="text-lg lg:text-xl font-semibold text-yellow-200 mb-6">All Complaints</h2>
        <table className="w-full border-collapse bg-gray-600 shadow-lg rounded-xl">
          <thead className="bg-red-700 text-white">
            <tr>
              <th className="p-3 text-left">Title</th>
              <th className="p-3 text-left">Type</th>
              <th className="p-3 text-left">Description</th>
              <th className="p-3 text-left">Location</th>
              <th className="p-3 text-left">Status</th>
            </tr>
          </thead>
          <tbody>
            {complaints.map((c) => (
              <tr key={c.id} className="border-b hover:bg-gray-700">
                <td className="p-3">{c.title}</td>
                <td className="p-3">{c.type}</td>
                <td className="p-3 text-sm text-white">{c.description}</td>
                <td className="p-3">{c.location}</td>
                <td className="p-3">
                  <span
                    className={`px-2 py-1 rounded-full text-xs font-medium ${
                      c.status === "Open"
                        ? "bg-red-100 text-red-700"
                        : c.status === "In Progress"
                        ? "bg-yellow-100 text-yellow-700"
                        : "bg-green-100 text-green-700"
                    }`}
                  >
                    {c.status}
                  </span>
                </td>
              </tr>
            ))}
          </tbody>
        </table>
      </div>
    </section>
  );
};

export default SyntraMfgComplaintHub;
